export class EventType {
  constructor(
    public code: string,
    public name: string
  ) { }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/event-type.ts